import { useEffect, useRef, useState, useCallback } from 'react';
import { createWSConnection, type WSEvent, type WSStatus } from '@/lib/ws';
import { getFirebaseAuth } from '@/lib/firebase';
import { resolveWsUrl } from '@/lib/ws-url';

interface UseWebSocketOptions {
  workshopId: string | null;
  onEvent?: (event: WSEvent) => void;
}

export function useWebSocket({ workshopId, onEvent }: UseWebSocketOptions) {
  const [status, setStatus] = useState<WSStatus>('disconnected');
  const onEventRef = useRef(onEvent);
  onEventRef.current = onEvent;

  const handleEvent = useCallback((event: WSEvent) => {
    onEventRef.current?.(event);
  }, []);

  useEffect(() => {
    if (!workshopId) return;

    const disconnect = createWSConnection({
      url: resolveWsUrl(),
      workshopId,
      getToken: async () => {
        const user = getFirebaseAuth().currentUser;
        if (!user) return null;
        return user.getIdToken();
      },
      onEvent: handleEvent,
      onStatusChange: setStatus,
    });

    return disconnect;
  }, [workshopId, handleEvent]);

  return { status };
}
